<template>
		<div class="layerPop" id="popPwChange" v-if="isVisible">
		<div class="popWrap">
			<div class="popBox popType1">
				<div class="popHead">
					<p class="popTit">비밀번호 수정</p>
				</div>
				<div class="popCon">
					<div class="tabStyle1">
						<table>
							<caption>비밀번호 수정</caption>
							<colgroup>
								<col width="140">
								<col width="*">
							</colgroup>
							<tbody>
								<tr v-if="state.sType != 1">
									<th scope="row">
										<label for="password">기존비밀번호</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input maxlength="20" v-model="state.oldPwd" type="password" id="oldPwd">
										</div>
									</td>
								</tr>
								<tr v-if="state.sType == 1">
									<th scope="row">
										<label for="password">가입된 아이디</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input maxlength="20" v-model="state.login_id" type="text" id="oldPwd" readonly>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="passwordNew">새비밀번호</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input maxlength="20" v-model="state.newPwd" type="password" id="newPwd">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="passwordNewChk">새비밀번호확인</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input maxlength="20" v-model="state.newPwdChk" type="password" id="newPwdChk">
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
					<div class="popBtn">
					<a  class="btnType sizeS colorB" @click="send()"><span>확인</span></a>
				</div>
				<slot></slot>
				<button type="button" class="popClose" @click="close()"><span class="hide">닫기</span></button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import util from '@/common/util'
import { sessionUserInfo, load } from '@/common/sessionFactory'

const axios = inject('axios')
const router = useRouter()
const state = reactive({
	oldPwd : '',
	newPwd : '',
	newPwdChk: '',
	login_id : '',
	biz_no : '',
	birth_ymd :'',
	tel_no2 : '',
	tel_no3 : '',
	sType : '',
});
const isVisible = ref(false);
const swalAlert = inject("swalAlert");

const emits = defineEmits(['update:data' ,'close']);

const open = async (object) => {
	state.oldPwd = '';
	state.newPwd = '';
	state.newPwdChk = '';
	isVisible.value =true;
	state.login_id = object.login_id;
	state.biz_no = object.biz_no;
	state.birth_ymd = util.formatDate(object.birth_ymd, 'yymmdd')
	state.tel_no2 = object.tel_no2;
	state.tel_no3 = object.tel_no3;
	state.sType = object.sType;
	console.log("pop state.sType" , state.sType)
}

const send = () => {
  	const data = {}
	if(state.sType != 1){
		if(_.isEmpty(state.oldPwd)){
			return swalAlert("기존 비밀번호를 입력하세요.")
		}
	}
	if(_.isEmpty(state.newPwd)){
		return swalAlert("새 비밀번호를 입력해주세요.")
	}
	if(_.isEmpty(state.newPwdChk)){
		return swalAlert("새 비밀번호확인을 입력해주세요.")
	}
	if(!_.isEqual(state.newPwd, state.newPwdChk)){
		return swalAlert("새 비밀번호 확인이 일치하지 않습니다.")
	}
	if(state.birth_ymd.includes(state.newPwd)){
		return swalAlert("생년월일 사용금지")
	}
	if(state.newPwd.includes(state.tel_no2) || state.newPwd.includes(state.tel_no3)){
		return swalAlert("전화번호 사용금지")
	}
	const goodFormat =  /^(?=.*\d)(?=.*[a-zA-Z])(?=.*\W).{8,20}$/.test(state.newPwd);
	if(!goodFormat) {
		return swalAlert("비밀번호 필수: 영문자 + 숫자 + 특수문자 <br> 최소 8자 / 최대 20자")
	}		
	const hasDuplicates = /([a-zA-Z0-9])\1{2,}/.test(state.newPwd);
	if(hasDuplicates) {
		return swalAlert("동일문자 3번이상 사용 금지")
	}		

	var isConSeq = false;
	var previousAsciiCode = 0;
	var  numSeqcount = 0;
    for (let i = 0; i < state.newPwd.length; i++) {
        var asciiCode = state.newPwd.charCodeAt(i);
        if ((previousAsciiCode + 1) == asciiCode || (previousAsciiCode - 1) == asciiCode) {
            numSeqcount++;
            if (numSeqcount >= 2) {
                isConSeq = true;
                break;
            }
        } else {
            numSeqcount = 0;
        }
        previousAsciiCode = asciiCode;
    }
	if (isConSeq) {
		return swalAlert("연속된문자(123, 321,abc, cba) 사용금지")
	}



	let param = {};
	param.login_id = state.login_id
	param.biz_no  = state.biz_no
	param.pwd_old = state.oldPwd
	param.pwd_new = state.newPwd
	param.sType = state.sType
	param.page = window.location.hash;
	axios.json('/pwCha.do', param).then(function(result){
		swalAlert(result.data.msg).then(async (result1) => {
			close();
			router.push({ name: 'main' })
		});
	})

}

const close = () => {
	isVisible.value =false;
	emits('close');
}
defineExpose({open , close})


</script>